import { useEffect, useState } from 'react';
import { toast } from 'sonner';
import WalletContextProvider from '@/components/ui/login/phantom/WalletContextProvider';
import { LayoutWithHeader } from '@/components/layout/Layout';
import useBreezeLogin from '@/hooks/useBreezeLogin';
import WalletCard from '@/components/ui/login/WalletCard';
import { useUser } from '@/hooks/useUser';
import * as Toast from '@/components/ui/toast/Toast';

export default function Login() {
  const [toastId, setToastId] = useState<string | number | null>(null);

  const { user } = useUser();
  useBreezeLogin();

  useEffect(() => {
    if (user?.isEmailUser) {
      const id = toast.custom(
        t => (
          <Toast.Default
            title="Wallet Required"
            description="AI Trainers does not support Google accounts. Sign in using Phantom or Breeze."
            buttons={[
              {
                label: 'Dismiss',
                onClick: () => toast.dismiss(t),
                variant: 'secondary',
                size: 'fw',
              },
            ]}
          />
        ),
        { duration: Infinity },
      );
      setToastId(id);
    }
  }, [user]);

  useEffect(() => {
    return () => {
      if (toastId) {
        toast.dismiss(toastId);
      }
    };
  }, [toastId]);

  return (
    <LayoutWithHeader>
      <div className="flex h-full flex-1 items-center justify-center">
        <WalletContextProvider>
          <WalletCard />
        </WalletContextProvider>
      </div>
    </LayoutWithHeader>
  );
}
